import { RootState } from "../../store";
import { RecommendationsSliceInterface } from "../utils/types/types";

export const recommendationsStateSelector = (
  state: RootState,
): RecommendationsSliceInterface => {
  return state.recommendations;
};
